import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ApplyIPOUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.applyIPO(req);
    }
}
export default ApplyIPOUseCase;
